// extracted by mini-css-extract-plugin
module.exports = {"container":"Static__container___1hoEJ"};